import { render, staticRenderFns } from "./VueDropzone.vue?vue&type=template&id=4135b8bb&"
import script from "./VueDropzone.vue?vue&type=script&lang=js&"
export * from "./VueDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports